import { generateMetricKey } from '@intelligence/v3/utils/metric';
import { DATASOURCE_KEY_MAP, NPD_METRIC_KEY_MAP } from './keyMap';

/**
 * NPD数据源Physical Revenue指标
 */
export const NPD_PHYSICAL_REVENUE_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.NPD,
  metric: NPD_METRIC_KEY_MAP.PHYSICAL_REVENUE,
});

/**
 * NPD数据源Physical Revenue指标环比
 */
export const NPD_PHYSICAL_REVENUE_METRIC_RATIO_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.NPD,
  metric: NPD_METRIC_KEY_MAP.PHYSICAL_REVENUE,
  ratio: true,
});

/**
 * NPD数据源Physical Units指标
 */
export const NPD_PHYSICAL_UNITS_METRIC_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.NPD,
  metric: NPD_METRIC_KEY_MAP.PHYSICAL_UNITS,
});

/**
 * NPD数据源Physical Units指标环比
 */
export const NPD_PHYSICAL_UNITS_METRIC_RATIO_KEY = generateMetricKey({
  dataSource: DATASOURCE_KEY_MAP.NPD,
  metric: NPD_METRIC_KEY_MAP.PHYSICAL_UNITS,
  ratio: true,
});
